<error-error-content 
  image="assets/img/images/error-images/image3.png"
  errorType="GATEWAY_TIMEOUT"
  copy="ERROR_504"></error-error-content>
